import { render, staticRenderFns } from "./VideoPlaylist.vue?vue&type=template&id=9194855c&scoped=true&"
import script from "./VideoPlaylist.vue?vue&type=script&lang=js&"
export * from "./VideoPlaylist.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlaylist.vue?vue&type=style&index=0&id=9194855c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9194855c",
  null
  
)

export default component.exports